import script from "./ExperimentList.vue?vue&type=script&setup=true&lang=js"
export * from "./ExperimentList.vue?vue&type=script&setup=true&lang=js"

import "./ExperimentList.vue?vue&type=style&index=0&id=67506de3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67506de3"]])

export default __exports__